import React from 'react';
import { Sparkles, Github, Twitter, Mail } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <motion.footer 
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="border-t border-white/10 py-12 mt-16 bg-gradient-to-b from-background to-background/95"
    >
      <div className="container mx-auto px-4">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand Section */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-4">
              <Sparkles className="h-6 w-6 text-purple-500" />
              <span className="font-bold text-xl">PromptAssist</span>
            </div>
            <p className="text-sm text-muted-foreground mb-6 max-w-md mx-auto md:mx-0">
              The #1 free AI prompt engineering platform helping developers create perfect prompts for ChatGPT, GitHub Copilot, and more.
            </p>
            <div className="flex items-center justify-center md:justify-start space-x-4">
              <a 
                href="https://github.com/Adong-o" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-purple-400 transition-colors"
                aria-label="GitHub"
              >
                <Github className="h-5 w-5" />
              </a>
              <a 
                href="https://twitter.com/AdongoJakes" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-purple-400 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a 
                href="mailto:ruothadongo@yahoo.com" 
                className="text-muted-foreground hover:text-purple-400 transition-colors"
                aria-label="Email"
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="text-center">
            <h3 className="font-semibold text-base mb-4">Quick Links</h3>
            <div className="space-y-3">
              <Link 
                to="/pricing" 
                className="block text-muted-foreground hover:text-purple-400 transition-colors text-sm"
              >
                Pricing
              </Link>
              <Link 
                to="/history" 
                className="block text-muted-foreground hover:text-purple-400 transition-colors text-sm"
              >
                History
              </Link>
              <Link 
                to="/blog" 
                className="block text-muted-foreground hover:text-purple-400 transition-colors text-sm"
              >
                Blog
              </Link>
              <Link 
                to="/terms" 
                className="block text-muted-foreground hover:text-purple-400 transition-colors text-sm"
              >
                Terms
              </Link>
            </div>
          </div>

          {/* Resources */}
          <div className="text-center">
            <h3 className="font-semibold text-base mb-4">Resources</h3>
            <div className="space-y-3">
              <Link 
                to="/docs" 
                className="block text-muted-foreground hover:text-purple-400 transition-colors text-sm"
              >
                Documentation
              </Link>
              <Link 
                to="/templates" 
                className="block text-muted-foreground hover:text-purple-400 transition-colors text-sm"
              >
                Prompt Templates
              </Link>
              <Link 
                to="/community" 
                className="block text-muted-foreground hover:text-purple-400 transition-colors text-sm"
              >
                Community
              </Link>
              <Link 
                to="/support" 
                className="block text-muted-foreground hover:text-purple-400 transition-colors text-sm"
              >
                Support
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-sm text-muted-foreground">
            © {currentYear} PromptAssist. All rights reserved. | 
            <Link to="/privacy" className="ml-2 hover:text-purple-400 transition-colors">Privacy Policy</Link> | 
            <Link to="/terms" className="ml-2 hover:text-purple-400 transition-colors">Terms of Service</Link>
          </p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
